<!--ZjwResource:结构化资源 - 试题 2020/11/12 18:06:41 YuAng-->

<template>
  <div style="width: 100%;height: 100%">
    <iframe id="iframe_zjw" :src="url" frameborder="0" width="100%" height="100%"></iframe>
    <download-qr-code></download-qr-code>
  </div>
</template>
<script>
import { getRequest } from '../../../utils/http'
import DownloadQrCode from '../home/components/DownloadQrCode.vue'
export default {
  components: { DownloadQrCode },
  name: 'ZjwResource',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    const route = encodeURIComponent(location.origin + '/index.html#/source/zjw') + '&zjcusp=' + encodeURIComponent('/homeworkcenter/jobs/')
    return {
      url: process.env.VUE_APP_URL_ZU_JUAN + '/customjump.aspx?_m=' + route
    }
  },
  async created() {
    this.$root.activeNavigation()
    await this.jumpGuideIfNeed()
  },
  methods: {
    async jumpGuideIfNeed() {
      const resp = await getRequest(location.origin + '/ibook/personal/sum-data', {})
      if (resp.body && !resp.body.hasClass) {
        this.$router.push('/guide/add-class?type=no_class&name=zjw')
      } else {
        const resp = await getRequest(location.origin + '/ibook/user-base-api/has-courses', {})
        if (!resp.body) {
          this.$router.push('/guide/add-class?type=no_course&name=zjw')
        }
      }
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function (to) {
        let path = encodeURIComponent(location.origin + '/index.html#/source/zjw')
        if (to.query.zjdsal) {
          if (location.href.indexOf('?') !== -1) {
            const paths = location.href.split('?')
            path = path + '&' + paths[1]
          }
        } else if (to.query.type === 'analysis') { // 作业报告
          const { bankId, hwkId, classId } = to.query
          const zjcusp = `/homeworkcenter/analysis/${bankId}h${hwkId}c${classId}`
          path = path + '&zjcusp=' + encodeURIComponent(zjcusp) + '&zjdsal=1'
        } else {
          path = path + '&zjcusp=' + encodeURIComponent('/homeworkcenter/jobs/')
        }
        this.url = process.env.VUE_APP_URL_ZU_JUAN + '/customjump.aspx?_m=' + path
      }
    }
  }
}
</script>

<style scoped>
#iframe_zjw {
  min-height: calc(100vh - 126px);
}
</style>